<template>
  <Bar
    v-bind:chart-data="chartData"
    v-bind:chart-options="chartOptions"
    class="1111"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';

/**
 * @description Генератор цветов
 * @return {Generator<string, void, *>}
 */
function* colorGenerator() {
  const colors = [
    '#0489E0',
    '#ff0000',
    '#D9E1EC',
    '#7371FF',
    '#EC782A',
    '#28b600',
    '#7f00af',
  ];
  let i = 0;
  while (i < colors.length) {
    const color = colors[i];
    yield color;
    i += 1;
    if (i === colors.length) {
      i = 0;
    }
  }
}

export default {
  name: 'SalesBar',
  components: {
    Bar,
  },
  computed: {
    chartData() {
      const colorVendor = colorGenerator();
      return {
        labels: this.labels,
        datasets: this.items.map((item) => ({
          label: item[this.itemLabelKey],
          backgroundColor: colorVendor.next().value,
          data: [item[this.itemValueKey]],
        })),
      };
    },
  },
  data() {
    return {
      chartOptions: {
        ...this.options,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          ...this.plugins,
        },
      },
    };
  },
  props: {
    /**
     * @description Элементы диаграммы
     * @type {Array}
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * @description Ключ метки элемента
     * @type {string}
     */
    itemLabelKey: {
      type: String,
      default: () => 'label',
    },
    /**
     * @description Ключ значения элемента
     * @type {string}
     */
    itemValueKey: {
      type: String,
      default: () => 'value',
    },
    /**
     * @description Плагины
     * @type {Object}
     */
    plugins: {
      type: Object,
      default: () => {},
    },
    /**
     * @description Опции
     * @type {Object}
     */
    options: {
      type: Object,
      default: () => {},
    },
    /**
     * @description Метки
     * @type {Array}
     */
    labels: {
      type: Array,
      default: () => [''],
    },
  },
};
</script>

<style scoped>

</style>
